import { Badge, NumberFormatter } from '@mantine/core';
import { useStoreMap, useUnit } from 'effector-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Player } from 'shared/api';
import BalanceIcon from 'shared/ui/assets/balance-icon.svg?react';
import { gamePageModel } from '../../model';
import { GamePageActiveIndicator } from '../game-page-active-indicator';
import cls from './game-page-player.module.scss';

export type GamePagePlayerProps = {
	playerId: number;
	actionSlot: (player: Player) => ReactNode;
};

export const GamePagePlayer = ({ playerId, actionSlot }: GamePagePlayerProps) => {
	const { t } = useTranslation();

	const player = useStoreMap({
		store: gamePageModel.$players,
		keys: [playerId],
		fn: (devices, [plrId]) => devices.find((plr) => plr.id === plrId)!,
	});

	const currency = useUnit(gamePageModel.$currency);

	return (
		<div
			key={player.name}
			className={cls.gamePagePlayer}
		>
			<div className={cls.gamePagePlayerLeftWrapper}>
				<div className={cls.gamePagePlayerGroup}>
					<Badge
						size='xl'
						radius='sm'
						data-number={player.order}
						className={cls.gamePageAccordionBadge}
					>
						{player.order}
					</Badge>
					<div className={cls.gamePagePlayerLabel}>
						<span className={cls.gamePagePlayerLabelName}>{player.name}</span>
						<GamePageActiveIndicator active={player.isConnected} />
					</div>
				</div>
				<div className={cls.gamePagePlayerBalance}>
					<BalanceIcon className={cls.gamePagePlayerBalanceIcon} />
					<span className={cls.gamePagePlayerBalanceLabel}>{t('game-page.balance')}: &nbsp;</span>
					<NumberFormatter
						value={player.balance}
						suffix={` ${currency}`}
					/>
				</div>
			</div>
			<div className={cls.gamePagePlayerBalanceButtons}>{actionSlot(player)}</div>
		</div>
	);
};
